import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { ToolbarForm } from '../toolbar-form/toolbar-form'
import { BasicSecurityFormDetails } from './BasicSecurityFormDetails';
import ValidationGroup from 'devextreme-react/validation-group';
import PutPostPatchFetch from '../../hooks/PutPostPatchFetch';
import BaseNotification from '../BaseNotification/BaseNotification';
import './BasicSecurityForm.scss';

/** @typedef {import('../../types/basicSecurityData').BasicSecurityData} BasicSecurityData */

/**
 * @param {BasicSecurityData} data 
 * @param {boolean} isLoading 
 * @param {boolean} isEditing 
 * @param {string} fileExtensions
 * @param {string} postPath
 * @param {string} backPath
 */

export const BasicSecurityForm = ({ data, fileExtensions, postPath, backPath, isEditing, isLoading = false }) => {
    const navigate = useNavigate();
    const navigateBack = () => navigate(backPath);
    const [editing, setEditing] = useState(isEditing);
    const [formInfo, setFormInfo] = useState(data);
    const [notification, setNotification] = useState({
        message: '',
        type: undefined,
        visible: false
    });
    const isNew = data?.Id === 0;
    const dataRef = useRef(null);


    useEffect(() => {
        setFormInfo(data);
    }, [data]);

    const handleEditClick = (e) => {
        if (editing === false && formInfo) {
            dataRef.current = formInfo;
        } else {
            dataRef.current = undefined;
        }
        setEditing(!editing);
    };

    const onSaveClick = async ({ validationGroup }) => {
        var formValid = validationGroup.validate().isValid;

        if (formValid === false) return;

        if (formValid === true) {
            setEditing(false);

        const formData = new FormData();
        formData.append("Files", formInfo.UploadFile.value[0]);

            let result;
            if (isNew) {
                result = await PutPostPatchFetch(`${postPath}${formInfo.BillDate}`, 'POST', formData, 'multipart/form-data'); 
            }

            if (result?.Success) {
                setNotification({
                    message: 'Basic Security Data Successfully Saved.',
                    type: 'success',
                    visible: true
                });
            };

            if (result?.Errors.length > 0) {
                setNotification({
                    message: result?.Errors[0].Message ?? 'Basic Security Data Not Saved.',
                    type: 'error',
                    visible: true
                });
            };
        }
    };

    const onBackClick = () => {
        navigateBack();
    };

    const onCancelClick = () => {
        navigateBack();
    };

    const updateField = (field, value) => {
        if (!formInfo) return;
        formInfo[field] = value;
    };

    const updateObject = (item, key, field, value) => {
        if (!formInfo) return;
        formInfo[item][key] = { ...formInfo[item][key], [field]: value };
    };


    return (
        <div className='basic-security-form'>
            <ValidationGroup>
                <ToolbarForm toggleEditing={handleEditClick} 
                    onSaveClick={onSaveClick} 
                    editing={editing} 
                    onBackClick={onBackClick} 
                    onCancelClick={onCancelClick} 
                    width="500px"
                />
                <BasicSecurityFormDetails
                    // loading={isLoading}
                    // hasData={!formInfo}
                    data={formInfo}
                    editing={editing}
                    fileExtensions={fileExtensions}
                    updateField={updateField}
                    updateObject={updateObject}
                />
            </ValidationGroup>
            <BaseNotification 
                message={notification.message}
                ref={useRef(null)}
                setter={() => setNotification(() => (
                    { 
                        isVisible: false,
                        message: '',
                        type: undefined
                    }
                ))}
                type={notification.type}
                visible={notification.visible}
            />
        </div>
    );
};